// extracted by mini-css-extract-plugin
module.exports = {"container":"IndividualForm_container__3rTH4"};